import { pl_thu } from "../../../models/response/danh-muc/pl_thu";
import { eThuActionTypeIds, IThuLoadStart, IThuLoadSuccess } from "../../action-types/danh-muc/IThuActionTypes";
import { BaseAction } from "../IBaseActionResult";

export const thuActions = {
    loadStart: (): IThuLoadStart => BaseAction(undefined, eThuActionTypeIds.LOAD_START),
    loadSuccess: (respone: pl_thu[]): IThuLoadSuccess => BaseAction(respone, eThuActionTypeIds.LOAD_SUCCESS),
}